// const anime = require("animejs");
const PerfectScrollbar = require("perfect-scrollbar");
// import PerfectScrollbar from 'perfect-scrollbar';

function scrollbar(parentContainer = document, className = "scrollbar") {

	// console.log(PerfectScrollbar);
	
	// const ps = new PerfectScrollbar('.scrollbar', {
	// 	swipeEasing: true,
	// 	suppressScrollX: true
	// });

	// const container = document.querySelector('#scrollbar');
	// const ps = new PerfectScrollbar(container);

	// const ps = new PerfectScrollbar('#scrollbar');

	// console.log('Success');

	// for (let i = 0; i < container.length; i++) {
	// 	const element = container[i];
	// 	console.log(element);
	// 	// var ps = new PerfectScrollbar(element);
	// 	// console.log(ps);
	// }

}

module.exports = scrollbar;


// WEBPACK FOOTER //
// ./resources/js/modules/scrollbar.js